import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useRef, useState } from "react";
import {
    Accordion,
    Badge,
    Button,
    Card,
    Col,
    Form,
    Image,
    Modal,
    Row,
    Alert
} from "react-bootstrap";
import configuration from "react-global-configuration";
import { t, translate } from "react-multi-lang";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import api from "../../Environment";
import "../Loader/spinner.css";
import "./BookingForm.css";
import axios from "axios";

function CheckoutForm({ onClose, clientSecret, props, booking }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const failureReportedRef = useRef(false);
    const successReportedRef = useRef(false);
    const dispatch = useDispatch();
    const history = useHistory();

    // Reset refs each time modal opens with a new clientSecret
    useEffect(() => {
        failureReportedRef.current = false;
        successReportedRef.current = false;
    }, [clientSecret]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setLoading(true);
        if (stripe) {

            const { error, setupIntent } = await stripe.confirmSetup({
                elements,
                confirmParams: {
                    payment_method_data: {
                        billing_details: {
                            name: booking.name || undefined,
                            email: booking.email || undefined,
                            address: {
                                country: "BS",
                            },
                        },
                    },
                },
                redirect: "if_required",
            });

            if (error) {
                console.log(error)
                setErrorMsg(error.message);
                setLoading(false);
            } else if (setupIntent.status === "succeeded") {

                const pmId = setupIntent.payment_method;

                // Save card in backend
                api
                    .postMethod("save_card", {
                        user_id: localStorage.getItem("userId"),
                        payment_method_id: pmId
                    })
                    .then(async (card_response) => {
                        if (!card_response.data.success || !card_response.data.card || !card_response.data.card.customer_id) {
                            setErrorMsg(card_response.data.error || "Failed to link card with customer. Please try again.");
                            setLoading(false);
                            return;
                        }

                        // create payment intent
                        api
                            .postMethod("create_payment_intent", {
                                user_id: booking.user_id,
                                event_id: booking.event_id,
                                ticket_price: booking.ticket_price,
                                number_of_persons: booking.number_of_persons,
                                name: booking.name,
                                email: booking.email,
                                customerId: card_response.data.card.customer_id,
                                paymentMethodId: pmId
                            })
                            .then(async (response) => {

                                if (response.data.success) {

                                    // Call Laravel API for success payment
                                    axios
                                        .post(
                                            process.env.REACT_APP_API_URL + "booking_payment_success",
                                            JSON.stringify({
                                                paymentIntent: response.data.data.paymentIntent,
                                                booking: booking,
                                                cardId: card_response.data.card.id
                                            }),
                                            {
                                                headers: {
                                                    "Content-Type": "application/json",
                                                },
                                            }
                                        )
                                        .then((response) => {
                                            setLoading(false);
                                            // ✅ Successful response
                                            console.log("Response data:", response);
                                            if (response.data.success) {
                                                //navigate to payment success page
                                                history.push("/payment-success");
                                            }
                                        })
                                        .catch((error) => {
                                            setLoading(false);
                                            // ✅ Handle errors
                                            if (error.response) {
                                                console.error("Error response:", error.response.data);
                                            } else {
                                                console.error("Error:", error.message);
                                            }
                                        });

                                } else {
                                    // 🚀 Call Laravel API for failed payment
                                    await fetch(process.env.REACT_APP_API_URL + "booking_payment_failed", {
                                        method: "POST",
                                        headers: { "Content-Type": "application/json" },
                                        body: JSON.stringify({
                                            paymentIntentId: response.data.paymentIntentId,
                                            booking: booking,
                                            error: error,
                                            cardId: card_response.data.card.id
                                        }),
                                    });

                                    setLoading(false);

                                    console.error("Payment failed:", error);
                                }
                            })
                    })
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{
            width: "100%", maxWidth: "100%"
        }}>
            <PaymentElement
                options={{
                    fields: {
                        billingDetails: {
                            address: {
                                country: "always",
                            },
                        },
                    },
                    defaultValues: {
                        billingDetails: {
                            name: booking.name || "",
                            email: booking.email || "",
                            address: {
                                country: "BS",
                            },
                        },
                    },
                }}
            />
            {/* {errorMsg && <div style={{ color: "red" }} className="mt-3">{errorMsg}</div>} */}

            <div className="modal-footer text-right mt-5">
                {/* <Button
                    type="button"
                    className="btn btn-danger width-btn mr-2"
                    data-dismiss="modal"
                    onClick={onClose}
                >
                    {t("cancel")}
                </Button> */}
                <button type="submit" className="btn btn-success width-btn  font-bold" disabled={!stripe || loading}>
                    {loading ? "Processing..." : `Save & Pay $${(booking.number_of_persons * booking.ticket_price).toFixed(2)}`}
                </button>
            </div>
        </form>
    );
}

const BookingForm = ({ onClose, props, booking }) => {

    // const stripeKey = configuration.get("configData.stripe_publishable_key");
    const stripeKey = "pk_test_51Jv2ibA21aUcoBnmpeKcwsa0VePi3SXy7JjrTd3BnTovSDbpDFSgUr3H61Zj6qWrVsgW383I5C2FKEH5echp7goT00NUjXFytx";

    const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const history = useHistory();
    const [clientSecret, setClientSecret] = useState("");
    const [selectedCard, setSelectedCard] = useState("");

    useEffect(() => {
        // create setup intent
        const inputData = {
            user_id: localStorage.getItem("userId"),
        };
        api
            .postMethod("create_setup_intent", inputData)
            .then(async (response) => {
                setClientSecret(response.data.clientSecret)
            })
            .catch((error) => {
                console.log("Error", error);
            });
    }, []);

    useEffect(() => {
        if (props.cards.data.cards.length > 0) {
            setSelectedCard(props.cards.data.cards.find((c) => c.is_default))
        }
    }, [props])

    const handlePayWithCard = async () => {

        setLoading(true);
        const UserId = selectedCard.user_id;
        const paymentMethodId = selectedCard.card_token;
        const totalAmount = Math.round(Number(booking.number_of_persons) * Number(booking.ticket_price) * 100);

        // Save card in backend
        api
            .postMethod("pay_with_saved_card", {
                user_id: UserId,
                payment_method_id: paymentMethodId,
                amount: totalAmount,
                ticket_price: booking.ticket_price,
                number_of_persons: booking.number_of_persons,
                event_id: booking.event_id,
            })
            .then(async (response) => {
                if (response.data.success && response.data.paymentIntent.status === "succeeded") {

                    // Call Laravel API for success payment
                    axios
                        .post(
                            process.env.REACT_APP_API_URL + "booking_payment_success",
                            JSON.stringify({
                                paymentIntent: response.data.paymentIntent,
                                booking: booking,
                                cardId: selectedCard.id
                            }),
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            }
                        )
                        .then((response) => {
                            setLoading(false);
                            // ✅ Successful response
                            console.log("Response data:", response);
                            if (response.data.success) {
                                //navigate to payment success page
                                history.push("/payment-success");
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            // ✅ Handle errors
                            if (error.response) {
                                console.error("Error response:", error.response.data);
                            } else {
                                console.error("Error:", error.message);
                            }
                        });
                } else {
                    // 🚀 Call Laravel API for failed payment
                    await fetch(process.env.REACT_APP_API_URL + "booking_payment_failed", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            paymentIntentId: clientSecret.split("_secret")[0],
                            booking: booking,
                            error: response.data,
                            cardId: selectedCard.id
                        }),
                    });
                    setLoading(false);
                    setErrorMsg(response.data.error);
                }
            })
            .catch((error) => {
                setLoading(false);
                setErrorMsg(error.message || "Payment failed. Please try again.");
            });
    }

    return (
        <Modal
            className="modal-dialog-center payment-add-card-modal"
            size="md"
            centered
            show={true}
            onHide={onClose}
        >
            <Form>
                <Modal.Header closeButton>
                    <Modal.Title>{t("payment")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} md={12} lg={12} xl={12}>
                            <Alert key="warning" variant="warning" className="d-flex align-items-center">
                                <i className="fas fa-exclamation-triangle fa-2x mr-3" />
                                <h5 style={{ marginBottom: "unset" }}>Please do not close popup when payment in progress.</h5>
                            </Alert>

                            <Accordion defaultActiveKey={props.cards.data.cards.length > 0 ? "0" : "1"} className="shadow-sm rounded border">
                                {/* Saved Cards */}
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" className="font-weight-bold">
                                        <Image
                                            src={
                                                window.location.origin + "/assets/images/icons/card.svg"
                                            }
                                            alt="Saved Cards"
                                            className="mr-2"
                                        />{" "}
                                        Saved Cards
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            {props.cards.data.cards.length > 0 ? (
                                                props.cards.data.cards.map((card) => (
                                                    <Card key={card.id} className="mb-3 shadow-sm">
                                                        {errorMsg && <div style={{ color: "red" }} className="mt-3">{errorMsg}</div>}
                                                        <Card.Body className="d-flex align-items-center">
                                                            <Form.Check
                                                                type="radio"
                                                                name="savedCard"
                                                                id={`card-${card.id}`}
                                                                className="me-3"
                                                                onChange={() => setSelectedCard(card)}
                                                                checked={selectedCard?.id === card.id}
                                                            />
                                                            <div>
                                                                <h5 className="mb-1 ml-3 text-capitalize">
                                                                    {card.card_type}{" "}
                                                                    <Badge className="ml-2 card-badge" variant="secondary"  >**** {card.last_four}</Badge>
                                                                </h5>
                                                                {/* <h5 className="text-muted">
                                                                Expires {card.card.exp_month}/{card.card.exp_year}
                                                            </h5> */}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                ))
                                            ) : (
                                                <p className="text-muted">No saved cards. Please add one.</p>
                                            )}

                                            {/* ✅ Only one button after the full list */}
                                            {props.cards.data.cards.length > 0 ?
                                                <div className="modal-footer text-right mt-3">
                                                    <button type="button" className="btn btn-success width-btn  font-bold" disabled={loading} onClick={handlePayWithCard}>
                                                        {loading ? "Processing..." : `Pay $${(booking.number_of_persons * booking.ticket_price).toFixed(2)}`}
                                                    </button>
                                                </div>
                                                : ""}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                {/* Add New Card */}
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1" className="font-weight-bold">
                                        <Image
                                            src={
                                                window.location.origin + "/assets/images/icons/plus.svg"
                                            }
                                            alt="Add New Card"
                                            className="mr-2"
                                        />{" "}
                                        Add New Card
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            {!clientSecret ? (
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}>
                                                    <div className="spinner" />
                                                </div>
                                            ) : (
                                                <Elements stripe={stripePromise} options={{ clientSecret }}>
                                                    <CheckoutForm onClose={onClose} clientSecret={clientSecret} props={props} booking={booking} />
                                                </Elements>
                                            )}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                </Modal.Body>
            </Form>
        </Modal >
    );
}

const mapStateToPros = (state) => ({
    singleEvent: state.event.singleEvent,
    session: state.event.session,
    bookingSuccess: state.event.bookingSuccess,
    bookingFailed: state.event.bookingFailed,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(BookingForm));